import { render, staticRenderFns } from "./td-emailOpt.vue?vue&type=template&id=1502a612&"
import script from "./td-emailOpt.vue?vue&type=script&lang=js&"
export * from "./td-emailOpt.vue?vue&type=script&lang=js&"
import style0 from "./td-emailOpt.vue?vue&type=style&index=0&id=1502a612&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports